import React from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';
import SubscribeForm from '@/components/Forms/Subscribe';

const LIST = [
  'Useful articles on the future of retail',
  'Market reports',
  'Cirrusoft news and updates',
];

const Subscribe = () => (
  <div className={styles.subscribe}>
    <div className={styles.subscribe_info}>
      <div className={styles.subscribe_info_l}>
        <h2 className="cr-h2">Subscribe to our monthly digest!</h2>
      </div>
      <div className={styles.subscribe_info_r}>
        <ul className={classnames('cr-checked-list')}>
          {LIST.map((val, i) => (
            <li key={i}>{val}</li>
          ))}
        </ul>
      </div>
    </div>
    <div>
      <SubscribeForm />
    </div>
  </div>
);

export default Subscribe;
